import './NavBar.less';
import { useLocation, useRouteMatch } from 'react-router-dom';
import React, { useEffect, useMemo } from 'react';
import useNavProject from '../../hooks/useNavProject';
import { NavSubItem } from './NavBar';

export default function NavBarIndexes(){
  const navProject = useNavProject();
  const indexMatch = useRouteMatch('/indexes');
  const indexNameMatch = useRouteMatch('/indexes/:type/*');
  const location = useLocation();

  const unifiedMatch = useRouteMatch('/indexes/unified-part')
  const calculationUnifiedMatch = useRouteMatch('/indexes/calculation-unified-part')

  const indexName = useMemo(() => {
    return indexNameMatch?.params?.type
  }, [indexNameMatch])

  useEffect(() => {
    if (!indexName && navProject.indexName) navProject.setIndexName(null)
  }, [indexName])

  return (
    <>
      {indexMatch && (
        <>
          {/* <NavSubItem style={{marginLeft: 8}} path={`/indexes/base-part`}>Целевые показатели эффективности (базовая часть гранта)</NavSubItem>
          <NavSubItem style={{marginLeft: 8}} path={`/indexes/special-part`}>Целевые показатели эффективности (специальная часть гранта)</NavSubItem>
          <NavSubItem style={{marginLeft: 8}} path={`/indexes/no-part`}>Показатели достижения результата</NavSubItem> */}
          <NavSubItem style={{marginLeft: 8}} path={`/indexes/fact-part`}>Данные для расчета фактических значений по показателям</NavSubItem>
          <NavSubItem style={{marginLeft: 8}} path={`/indexes/unified-part`}>Унифицированные показатели проектов</NavSubItem>
          {unifiedMatch && indexName && navProject.indexName && (
            <>
              <NavSubItem style={{marginLeft: 16}} inactive={!indexName} path={`${indexNameMatch.url}${location.search}`}>{navProject.indexName}</NavSubItem>
            </>
          )}
          <NavSubItem style={{marginLeft: 8}} path={`/indexes/calculation-unified-part`}>Данные для расчета унифицированных показателей проекта</NavSubItem>
          {calculationUnifiedMatch && indexName && navProject.indexName && (
            <>
              <NavSubItem style={{marginLeft: 16}} inactive={!indexName} path={`${indexNameMatch.url}${location.search}`}>{navProject.indexName}</NavSubItem>
            </>
          )}
        </>
      )}
    </>
  )
}
